import { Link } from "react-router-dom";
import { Box, Button, CardMedia, Typography } from "@mui/material";
import noDataImg from "@arelia-assets/no-data.svg";
import { PATHS } from "../../routes";
import { CONSTANTS } from "@arelia-utils/constants/constants";

type Props = {
  minified: boolean;
  btnVariant?: 'text' | 'outlined';
  btnColor?: 'primary' | 'secondary';
  btnMarginT?: number;
};

export default function EmptyState({
  minified,
  btnVariant = 'text',
  btnColor = 'primary',
  btnMarginT = 2
}: Props) {
  const navigateLink = PATHS.ACCOUNT + "/connections";

  return (
    <Box display="flex" flexDirection="column" flex="1" justifyContent="center" alignItems="center">
      <CardMedia
        sx={{ backgroundSize: "contain", height: 45, width: 70, mt: 1, mb: 2 }}
        image={noDataImg}
        title="Image Title"
      />
      <Typography variant="subtitle1" color="secondary">
        No data found
      </Typography>
      {!minified &&
        <>
          <Typography variant="body2" color="secondary" sx={{ mt: 1, mb: 1, textAlign: "center" }}>
            {CONSTANTS.UI_MESSAGES.AUTH_ERROR}
          </Typography>
          <Button
            component={Link}
            to={navigateLink}
            variant={btnVariant}
            color={btnColor}
            sx={{ mt: btnMarginT }}
          >
            Go to connections
          </Button>
        </>
      }
    </Box>
  )
}

